import { requestSLSImageData } from '@fs/zion-sls'
import { headers } from '../../../shared/services/config'

export default async function getCollectionIds(tasks) {
  // Get the arks (partition keys) from the tasks and dedupe them
  const partitionKeys = [...new Set(tasks.map((task) => task.ark))]

  // Get the collection ids
  const collectionIds = await Promise.all(
    partitionKeys.map(async (partitionKey) => {
      const response = await requestSLSImageData({
        partitionKey,
        fsUserAgentChain: headers['FS-User-Agent-Chain'],
        includeActions: false,
      })
      const collectionId = response?.elements[0]?.collectionId

      if (!collectionId) return 'No collection ID available'

      return +collectionId
    })
  )

  // Return deduped collection ids
  return [...new Set(collectionIds)]
}
